document.addEventListener('DOMContentLoaded', function () {
  lawyer_tip_modle();
  recommend_card_modle();
});

//--- 繼續閱覽相關主題文章
function recommend_card_modle() {
  // 取得 a-theme, a-url, b-theme, b-url 屬性
  const recommendCardModle = document.querySelector('.recommend-card-modle');
  const aTheme = recommendCardModle.getAttribute('data-a-theme');
  const aUrl = recommendCardModle.getAttribute('data-a-url');
  const bTheme = recommendCardModle.getAttribute('data-b-theme');
  const bUrl = recommendCardModle.getAttribute('data-b-url');
  
  // 生成頂部區塊：女律師圖 + 標題同行
  const topHtml = `
    <div class="card-header">
      <img src="https://cdn.shopify.com/s/files/1/0892/8680/3757/files/ChatGPT_Image_2025_5_17___09_44_40-removebg-preview.png?v=1747491490" alt="女律師圖示">
      <h3>繼續閱覽相關主題文章</h3>
    </div>
  `;
  
  // 生成卡片區塊
  const cardsHtml = `
    <div class="card-column"> 
      <div class="recommend-card">
        <img src="https://cdn.shopify.com/s/files/1/0892/8680/3757/files/ChatGPT_Image_2025_5_17___10_24_09-removebg-preview.png?v=1747492243" alt="${aTheme}圖示">
        <div class="recommend-card-content">
          <p>還想進一步了解 <strong>${aTheme}</strong> 嗎？</p>
          <a href="${aUrl}">➔ 立即查看，全面解析！</a>
        </div>
      </div> 
      <div class="recommend-card">
        <img src="https://cdn.shopify.com/s/files/1/0892/8680/3757/files/ChatGPT_Image_2025_5_17___10_24_52-removebg-preview.png?v=1747492255" alt="${bTheme}圖示">
        <div class="recommend-card-content">
          <p>想知道更多關於 <strong>${bTheme}</strong> 的詳情？</p>
          <a href="${bUrl}">➔ 點擊閱讀，深入了解！</a>
        </div>
      </div>
    </div>
  `;
  
  // 將生成的 HTML 插入到指定位置
  recommendCardModle.outerHTML = topHtml + cardsHtml;
}

//--- 律師小提醒
function lawyer_tip_modle(){
  // 找到所有的 .lawyer-tip-modle 元素
  const lawyerTipModles = document.querySelectorAll('.lawyer-tip-modle');
  
  // 遍歷每一個元素
  lawyerTipModles.forEach(lawyerTipModle => {
    // 從原本元素中取得 data 屬性值
    const lawyerMessage = lawyerTipModle.getAttribute('data-tip');
  
    // 生成新的 HTML 結構
    const newHtml = `
      <div class="lawyer-tip">
        <div class="lawyer-tip-left">
          <img src="https://cdn.shopify.com/s/files/1/0892/8680/3757/files/2025_5_12_04_56_46.png?v=1746997063" alt="律師頭像">
          <div class="lawyer-tip-label">律師有話說</div>
        </div>
        <div class="lawyer-tip-right">
          ${lawyerMessage}
        </div>
      </div>
    `;
  
    // 用新生成的 HTML 替換原來的元素
    lawyerTipModle.outerHTML = newHtml;
    
    const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      } else {
        entry.target.classList.remove('visible');
      }
    });
  }); 
    document.querySelectorAll('.lawyer-tip').forEach(tip => {
      observer.observe(tip);
    });
  });
}